/*! Oruga v0.8.12 | MIT License | github.com/oruga-ui/oruga */
import { _ as _sfc_main } from "./Timepicker.vue_vue_type_script_setup_true_lang-B7TreYFS.mjs";
import { b as registerComponent } from "./config-C1k5NuG7.mjs";
const index = {
  install(app) {
    registerComponent(app, _sfc_main);
  }
};
export {
  _sfc_main as OTimepicker,
  index as default
};
//# sourceMappingURL=timepicker.mjs.map
